"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PickString = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const TextFieldWithStateAndBlur_1 = __importDefault(require("@opsbase/web-textfield/TextFieldWithStateAndBlur/TextFieldWithStateAndBlur"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const react_1 = __importStar(require("react"));
function PickString(props) {
    const { onSelect, queryField, onCancel } = props;
    const [value, setValue] = (0, react_1.useState)('');
    const handleClickCancel = (0, react_1.useCallback)(() => {
        onCancel === null || onCancel === void 0 ? void 0 : onCancel();
    }, [onCancel]);
    const handleClickOk = (0, react_1.useCallback)(() => {
        const v = value.trim();
        onSelect({ queryFieldKey: queryField.key, id: v, title: 'matches "' + v + '"' });
    }, [onSelect, queryField, value]);
    return (react_1.default.createElement(Vertical_1.default, { padding: true, gutter: true },
        react_1.default.createElement(TextFieldWithStateAndBlur_1.default, { fullWidth: true, value: value, onBlur: setValue, label: "Search..." }),
        react_1.default.createElement(Horizontal_1.default, { gutter: true },
            react_1.default.createElement(Button_1.default, { onClick: handleClickCancel, color: lib_palette_1.default.LavendarGrey, label: 'Cancel' }),
            react_1.default.createElement(Button_1.default, { onClick: handleClickOk, color: lib_palette_1.default.positive, label: 'Ok' }))));
}
exports.PickString = PickString;
exports.default = PickString;
